(() => {
  'use strict';
  const init = (root = document) => {
    // Keep the merchant's existing application link usable as text if its external image fails.
    root.querySelectorAll('a[href="https://www.mysynchrony.com/mmc/LX176117800"] img[src="https://www.synchronybusiness.com/mmc/assets/syf_apply_218.png"]:not([data-monaco-fallback-ready])').forEach(image => {
      image.dataset.monacoFallbackReady = 'true';
      const showLabel = () => {
        if (!image.isConnected || image.naturalWidth || !image.alt.trim()) return;
        const label = document.createElement('span');
        label.className = 'monaco-financing-label';
        label.textContent = image.alt;
        image.replaceWith(label);
      };
      image.addEventListener('error', showLabel, {once:true});
      if (image.complete && !image.naturalWidth) showLabel();
    });
    const toggle = document.querySelector('.menu-toggle');
    const menu = document.getElementById('mobile-menu');
    if (toggle && menu && !toggle.dataset.monacoReady) {
      toggle.dataset.monacoReady = 'true';
      toggle.addEventListener('click', () => {
        menu.hidden = !menu.hidden;
        toggle.setAttribute('aria-expanded', String(!menu.hidden));
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }));
    }
    root.querySelectorAll('.monaco-tabs:not([data-ready])').forEach(tablist => {
      tablist.dataset.ready = 'true';
      const tabs = [...tablist.querySelectorAll('[data-monaco-tab]')];
      const choose = (index, focus = false) => tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = i !== index;
        if (focus && i === index) tab.focus();
      });
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => choose(i));
        tab.addEventListener('keydown', event => {
          const actions = {ArrowLeft:(i + tabs.length - 1) % tabs.length, ArrowRight:(i + 1) % tabs.length, Home:0, End:tabs.length - 1};
          if (!(event.key in actions)) return;
          event.preventDefault();choose(actions[event.key], true);
        });
      });
      choose(0);
    });
    root.querySelectorAll('[data-monaco-related]:not([data-ready])').forEach(section => {
      section.dataset.ready = 'true';
      const items = [...section.querySelectorAll('.monaco-related-grid > li')];
      if (!items.length) return;
      const track = section.querySelector('.monaco-related-track');
      const previous = section.querySelector('[data-monaco-prev]');
      const next = section.querySelector('[data-monaco-next]');
      const status = section.querySelector('[data-monaco-status]');
      const phone = matchMedia('(max-width: 760px)');
      const tablet = matchMedia('(max-width: 1024px)');
      const size = () => phone.matches ? 2 : tablet.matches ? 3 : 4;
      let start = 0;
      const last = () => Math.floor((items.length - 1) / size()) * size();
      const render = () => {
        items.forEach((item, index) => { item.hidden = index < start || index >= start + size(); });
        previous.setAttribute('aria-disabled', String(start === 0));
        next.setAttribute('aria-disabled', String(start >= last()));
        status.textContent = `${start + 1}–${Math.min(start + size(), items.length)} / ${items.length}`;
      };
      const move = target => {start = Math.max(0, Math.min(target, last()));render();};
      previous.addEventListener('click', () => move(start - size()));
      next.addEventListener('click', () => move(start + size()));
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        const actions = {ArrowLeft:start-size(), ArrowRight:start+size(), PageUp:start-size(), PageDown:start+size(), Home:0, End:last()};
        if (!(event.key in actions)) return;
        event.preventDefault();move(actions[event.key]);
      });
      const resize = () => {
        const focus = items.findIndex(item => item.contains(document.activeElement));
        const anchor = focus < 0 ? start : focus;
        move(Math.floor(anchor / size()) * size());
      };
      phone.addEventListener('change', resize);tablet.addEventListener('change', resize);
      section.querySelector('[data-monaco-pager]').hidden = false;
      render();
    });
    root.querySelectorAll('[data-monaco-recommendations]:not([data-loading])').forEach(async placeholder => {
      placeholder.dataset.loading = 'true';
      try {
        const url = new URL(placeholder.dataset.url, location.origin);
        if (url.origin !== location.origin) return;
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = parsed.querySelector('[data-monaco-related]');
        if (!section) return;
        placeholder.replaceWith(section);init(document);
      } catch {}
    });
    root.querySelectorAll('[data-monaco-watch-track]:not([data-ready])').forEach(track => {
      track.dataset.ready = 'true';
      const section = track.closest('[data-monaco-watch-feed]');
      const previous = section.querySelector('[data-monaco-watch-prev]');
      const next = section.querySelector('[data-monaco-watch-next]');
      const controls = section.querySelector('[data-monaco-watch-controls]');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const bounds = () => {const end = Math.max(0,track.scrollWidth-track.clientWidth);controls.hidden=end<2;previous.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=end-2;};
      const go = target => track.scrollTo({left:target,behavior:reduce.matches?'auto':'smooth'});
      previous.addEventListener('click',()=>go(track.scrollLeft-track.clientWidth));
      next.addEventListener('click',()=>go(track.scrollLeft+track.clientWidth));
      track.addEventListener('keydown',event=>{if(event.target!==track)return;const values={ArrowLeft:track.scrollLeft-track.clientWidth,ArrowRight:track.scrollLeft+track.clientWidth,Home:0,End:track.scrollWidth};if(!(event.key in values))return;event.preventDefault();go(values[event.key]);});
      track.addEventListener('scroll',bounds,{passive:true});new ResizeObserver(bounds).observe(track);bounds();
    });
    root.querySelectorAll('[data-monaco-watch-feed]:not([data-feed-ready])').forEach(async feed => {
      feed.dataset.feedReady = 'true';
      try {
        const url = new URL(feed.dataset.feedUrl, location.origin);
        if (url.origin !== location.origin) return;
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = parsed.querySelector('[data-monaco-watch-feed]');
        if (!next || !next.querySelector('.monaco-product-card')) return;
        next.dataset.feedReady = 'true';feed.replaceWith(next);init(document);
      } catch {}
    });
  };
  init();
  document.addEventListener('shopify:section:load', () => init());
})();
